import { Box } from "@prismicio/editor-ui"

import { useSelectedMedia } from "../../hooks/useSelectedMedia"
import { useMediaLibrary } from "../MediaLibraryContext"
import { SidepaneHeader } from "./components/SidepaneHeader"
import { SidepaneImage } from "./components/SidepaneImage"
import { SidepaneMetadata } from "./components/SidepaneMetadata"
import { SidepaneTagManager } from "./components/SidepaneTagManager"
import { DefaultSidepaneContent } from "./DefaultSidepaneContent"

export function SidepaneContent() {
  const selectedMedia = useSelectedMedia()
  const { onFilesUpload, isUploading, tagManagerOpen } = useMediaLibrary()

  if (selectedMedia.length === 0 && tagManagerOpen === false)
    return (
      <DefaultSidepaneContent
        onFilesUpload={onFilesUpload}
        isUploading={isUploading}
      />
    )

  return (
    <Box
      flexDirection="column"
      backgroundColor="grey1"
      width="100%"
      padding={16}
      gap={16}
      borderRadius={{
        topLeft: 8,
        topRight: 8
      }}
    >
      {tagManagerOpen ? (
        <SidepaneTagManager />
      ) : (
        <>
          <SidepaneHeader />
          <SidepaneImage />
          <SidepaneMetadata />
        </>
      )}
    </Box>
  )
}
